import { render } from "./insure-daily-plan.vue?vue&type=template&id=6d6968a4&scoped=true&ts=true"
import script from "./insure-daily-plan.vue?vue&type=script&lang=ts"
export * from "./insure-daily-plan.vue?vue&type=script&lang=ts"

import "./insure-daily-plan.vue?vue&type=style&index=0&id=6d6968a4&lang=stylus&scoped=true"

import exportComponent from "D:\\Repository\\Zidan\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d6968a4"]])

export default __exports__